import { MenuItem } from "@blueprintjs/core";
import { ItemPredicate, ItemRenderer, Select } from "@blueprintjs/select";
import * as React from "react";
import { IEmpresa } from "../../model";
import { formatCnpj } from "../../utils";

export const EmpresaSelect = Select.ofType<IEmpresa>();

export const filterEmpresa: ItemPredicate<IEmpresa> = (query, empresa) => {
  let empresa_text = `${empresa.razao_social.toLowerCase()} - ${empresa.cnpj}`
  return empresa_text.indexOf(query.toLowerCase().replace(/[^a-zA-Z0-9\s]/g, "")) >= 0;
};

export const renderEmpresa: ItemRenderer<IEmpresa> = (
  empresa,
  { handleClick, modifiers },
) => {
  if (!modifiers.matchesPredicate) {
    return null;
  }
  return (
    <MenuItem
      active={modifiers.active}
      key={empresa.id}
      text={empresa.razao_social}
      onClick={handleClick}
      label={formatCnpj(empresa.cnpj)}
    />
  );
};
